import React from 'react';
import map1 from '../../../images/Map/map.jpg'

const Contact = () => {
    return (
        <div>
            <h1>Contact us</h1>
            <div className="row">
                <div>
                    <img src={map1} alt="" />
                </div>
            </div>
            <ul>
                <li><h1> Call: 01866833333 </h1></li>
                <li><h1> Mail: istiakiqbal@gmail.com</h1> </li>
                <li><h1> Location: Chittagong, Bangladesh </h1></li>
            </ul>
        </div>
    );
};

export default Contact;